module.exports = __webpack_public_path__ + "img/color-wheel (1).4b3f253b.png";